import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './courseManagement.css';
import plus_icon from "../../../assets/dashboard/plus-icon.svg";
import moment from 'moment';
import ProgressDashes from './ProgressDashes';
import { downloadCourseByAdmin } from '../../../services/Admin/admin';
import { toast } from 'react-toastify';

const CourseTable = ({ courses,onDeclineCourse, onDeleteCourse, onAccept }) => {
    const navigate = useNavigate();
    const [openDropdownId, setOpenDropdownId] = useState(null); // track which dropdown is open
    const [dropUpIds, setDropUpIds] = useState({});
    const onEdit = (id) => {
        navigate(`edit-course/${id}`);
    };
      const [downloading , setDownloading] = useState(false)

    const handleToggle = (e, id) => {
        e.stopPropagation();
        const buttonRect = e.currentTarget.getBoundingClientRect();
        const dropdownHeight = 120; // Approx height of dropdown

        const shouldDropUp = window.innerHeight - buttonRect.bottom < dropdownHeight;
        setDropUpIds(prev => ({ ...prev, [id]: shouldDropUp }));
        setOpenDropdownId(prev => (prev === id ? null : id));
    };

    // const handleToggle = (e, id) => {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     setOpenDropdownId(prevId => (prevId === id ? null : id)); // toggle this one
    // };

    const handleAccept = (id) => {
        onAccept(id);
        setOpenDropdownId(null);
    };

    const handleDelete = (id) => {
        onDeleteCourse(id);
        setOpenDropdownId(null);
    };

        
    const downloadFile = async () => {
        setDownloading(true)
      try {
        const rawCsv = await downloadCourseByAdmin(); // CSV string
        if (!rawCsv || typeof rawCsv !== "string" || rawCsv?.data?.length == 0) {
          toast.error(rawCsv?.message || "There is no data found")
          setDownloading(false)
          return;
        }
    
        // Split lines
        const lines = rawCsv.trim().split("\n");
    
        // Extract headers from the first line
        const headers = lines[0].split(",");
    
        // Convert each line to an object
        const data = lines.slice(1).map(line => {
          const values = line.split(",");
          const obj = {};
          headers.forEach((header, index) => {
            obj[header.trim()] = values[index]?.trim() ?? "";
          });
          return obj;
        });
    
        // Confirm parsed data
        console.log("Parsed CSV Data:", data);
    
        // Generate downloadable CSV again (in case you want to filter or just force the download)
        const csvRows = [
          headers.join(","),
          ...data.map(row =>
            headers.map(field => `"${(row[field] ?? "").replace(/"/g, '""')}"`).join(",")
          ),
        ];
    
        const csvContent = csvRows.join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
    
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "course_export.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setDownloading(false)
        toast.success("File download Successfully!");
    
      } catch (error) {
        setDownloading(false)
        console.error("Download failed:", error);
        toast.error("Something went wrong while downloading the CSV.");
      }
    };

    return (
        <div className="management-container">
            <div className="management-header">
                <h2>Course Management</h2>
                <div className="button-group">
                   <button className="export-btn" onClick={()=>downloadFile()}
                        disabled={downloading}
                        >
                            {downloading ? 
                             "loading...."
                        :
                        <>
                        <i className="bi bi-file-earmark-arrow-down me-2"></i> Export
                        </>
                        }
                        
                    </button>
                </div>
            </div>

            <div className="table-container">
                <table className="course-table">
                    <thead>
                        <tr>
                            <th colSpan="5">
                                <div className="admin-course-table-header table-header">
                                    <div className="cell">Sr #</div>
                                    <div className="cell">Course List</div>
                                    <div className="cell">Name</div>
                                    <div className="cell">Verified</div>
                                    <div className="cell">Date of upload</div>
                                    <div className="cell">View</div> 
                                    <div className="cell">Action</div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                         {
                            courses && courses?.length > 0 ?
                                <>
                                {courses && courses.map((course, index) => (
                            <tr key={course._id}>
                                <td colSpan="5">
                                    <div className="admin-course-table-row table-row">
                                        <div className="cell">{index + 1}</div>
                                        <div className="cell">{course.title}</div>
                                        <div className="cell">{course?.addedBy?.fullName}</div>

                                        {/* <div className="cell "><ProgressDashes current={5} total={5} /></div> */}
                                        <div className="cell">{course.isVerified ? "YES" : "NO"}</div>
                                        <div className="cell">{moment(course?.createdAt).format("DD-MM-YYYY")}</div>
                                        <div className="cell">

                                             <button
                                                    className="delete-btn d-flex justify-content-between align-items-center w-100"
                                                    onClick={(e) => {
                                                        navigate(`${course?._id}`)
                                                    }}
                                                >
                                                    <i className="bi bi-eye" style={{color:'black'}}></i>
                                                </button>
                                        </div>
                                        <div className="cell action" style={{ position: 'relative' }}>
                                            <div onClick={(e) => e.stopPropagation()}>
                                                <button
                                                    type="button"
                                                    className="action-button"
                                                    onClick={(e) => handleToggle(e, course._id)}
                                                >
                                                    <i className="bi bi-three-dots"></i>
                                                </button>

                                                {openDropdownId === course._id && (
                                                    <div
                                                        className={`dropdown-menu show ${dropUpIds[course._id] ? 'drop-up' : ''}`}
                                                        style={{
                                                            position: 'absolute',
                                                            top: dropUpIds[course._id] ? 'auto' : '35px',
                                                            bottom: dropUpIds[course._id] ? '35px' : 'auto',
                                                            zIndex: 10,
                                                        }}
                                                    >
                                                        <button
                                                            type="button"
                                                            className="assign-btn d-flex justify-content-between align-items-center w-100"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleAccept(course._id);
                                                            }}
                                                        >
                                                            <span className="text-success">Accept</span>
                                                            {/* <img src={plus_icon} alt="plus" width={25} height={25} /> */}
                                                            <span className="icon-circle bg-success-subtle text-success ms-2">
                                                    <i className="bi bi-check-lg"></i>
                                                </span>
                                                        </button>
                                                        <button
                                                    className="delete-btn d-flex justify-content-between align-items-center w-100"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        onDeclineCourse(course._id);
                                                    }}
                                                >
                                                    <span className="text-danger">Decline</span>
                                                    <span className="icon-circle bg-danger-subtle text-danger ms-2">
                                                        <i className="bi bi-x-lg"></i>
                                                    </span>
                                                </button>
                                                         

                                                        <button
                                                            type="button"
                                                            className="delete-btn d-flex justify-content-between align-items-center w-100"
                                                            onClick={() => handleDelete(course._id)}
                                                        >
                                                            <span className="text-danger">Delete</span>
                                                            <span className="icon-circle bg-danger-subtle text-danger ms-2">
                                                                <i className="bi bi-trash-fill"></i>
                                                            </span>
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                                </>
                                :
                                <div
                className="col-md-12"
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '200px', // Adjust as needed
                  gap: '8px',
                  fontSize: '18px',
                  color: '#666'
                }}
              >
                <i className="bi bi-info-circle" style={{ fontSize: '20px' }}></i>
                No records found
              </div>
                        }
                        
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CourseTable;
